<template>
	<div>
		<titlebar :title="$route.name" />
		<router-view />
	</div>
</template>

<script>
import Titlebar from '@/components/admin/Titlebar'
export default {
	name: 'accounts',
	components: {
		Titlebar
	}
}
</script>
